/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable spaced-comment */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Permission from 'components/ValidPermission';
import {
  AppBar,
  Avatar,
  Divider,
  Grid,
  IconButton,
  makeStyles,
  Toolbar,
  Typography,
} from '@material-ui/core';
import PhotoIcon from '@material-ui/icons/AccountBox';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HelpCenterIcon from '@material-ui/icons/Help';
import MenuIcon from '@material-ui/icons/Menu';
import LayersIcon from '@material-ui/icons/Layers';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import PublicIcon from '@material-ui/icons/Public';
import ScreenShareIcon from '@material-ui/icons/ScreenShare';
import clsx from 'clsx';
import {
  selectCompany,
  selectPartner,
  authenticateLogout,
} from 'modules/authenticate/actions';
import ChangeLanguage from 'components/ChangeLanguage';
import DialogAlert, {
  DialogAlertInitial,
  DialogAlertProps,
} from 'components/DialogAlert';
import DropMenu, {
  DropMenuItem,
  FooterProps,
  HeaderProps,
} from 'components/DropMenu';
import { getOperatorRequest } from 'modules/operators/actions';
import i18n, { changeLanguage } from 'i18n';

import { modalClose, modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import { messagesRequest } from 'modules/messages/actions';
import React from 'react';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import ApplicationState from 'store/interfaces';
import { GetOperatorFields } from 'modules/operators/interfaces';
import {
  CompanyData,
  PartnerData,
  RolesEnum,
  PermissionsData,
} from 'modules/authenticate/interfaces';
import { ListCompanyDataProps } from 'modules/companies/interfaces';
import { ListPartnerDataProps } from 'modules/partners/interfaces';
import Button from 'components/Button';
import useWindowDimensions from 'hooks/useWindowWidth';
import { inAdminView, inOperatorView, isClientOperator } from 'utils/role';
import FormSwitchRegion from './FormSwitchRegion';
import styles from './styles';

const useStyles = makeStyles(styles);

interface OwnProps {
  operator_uuid: string;
  companyList: ListCompanyDataProps;
  companySelected: CompanyData | null;
  partnerSelected: PartnerData | null;
  partnerList: ListPartnerDataProps;
  partnerLoading: boolean;
  permissions?: PermissionsData;
  operatorDetails: GetOperatorFields | null;
  availableRegions: Array<{
    abbreviation: string;
    name: string;
    code: string;
    url: string;
  }>;
  currentRegion: string;
  role?: RolesEnum;
  operator_first_name?: string;
  operator_last_name?: string;
  toggleMenu: () => void;
  openSelectCompany: () => void;
  openSelectPartner: () => void;
  selectCompany: (company: CompanyData | null) => void;
  selectPartner: (partner: PartnerData | null) => void;
  authenticateLogout: () => void;
  modalOpen: (props: ModalFields) => void;
  modalClose: () => void;
  getOperatorRequest: (id: string) => void;
  messagesRequest: (props) => void;
}

interface DropMenuProps {
  event: React.MouseEvent<HTMLElement>;
  header?: HeaderProps | null;
  footer?: FooterProps;
  items: React.ReactNode;
}

const TopNavBar: React.FC<OwnProps> = ({
  operator_uuid,
  companyList,
  companySelected,
  partnerSelected,
  partnerList,
  partnerLoading,
  permissions,
  availableRegions,
  operatorDetails,
  currentRegion,
  role,
  operator_first_name,
  operator_last_name,
  selectCompany,
  selectPartner,
  authenticateLogout,
  toggleMenu,
  openSelectCompany,
  openSelectPartner,
  modalClose,
  modalOpen,
  getOperatorRequest,
  messagesRequest,
}) => {
  const classes = useStyles();
  const history = useHistory();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [dropHeader, setDropHeader] = React.useState<null | HeaderProps>(null);
  const [dropFooter, setDropFooter] = React.useState<null | FooterProps>(null);
  const [dropItems, setDropItems] = React.useState<null | React.ReactNode>(
    null
  );
  const [alert] = React.useState<DialogAlertProps>(DialogAlertInitial);

  const [tutorial] = React.useState({
    pt:
      'https://skyinone.atlassian.net/wiki/spaces/AUTODOCPTBR/overview?homepageId=530972741',
    es: 'https://skyinone.atlassian.net/wiki/spaces/APDE/overview',
    en: 'https://skyinone.atlassian.net/wiki/spaces/AUTODOC/overview',
  });

  const inSuperAdminView: boolean =
    role === RolesEnum.superAdmin && !companySelected;

  const openDropMenu = ({
    event,
    header = null,
    footer,
    items,
  }: DropMenuProps) => {
    setAnchorEl(event.currentTarget);
    setDropHeader(header);
    setDropFooter(footer || null);
    setDropItems(items);
  };

  const closeDropMenu = () => {
    setAnchorEl(null);
    setDropHeader(null);
    setDropItems(null);
  };

  const handleConfirmLogout = () => {
    modalOpen({
      title: i18n.t('WANT_LOGOUT_SESSION_KEY'),
      content: (
        <Grid container justify="center">
          <Grid container justify="center">
            <NotificationsActiveIcon
              className={clsx(classes.iconFormat, {
                [classes.grayHeader]: inSuperAdminView,
                [classes.greenHeader]: inAdminView(role, companySelected),
                [classes.blueHeader]: inOperatorView(role, companySelected),
              })}
            />
          </Grid>
          <p className={classes.logoutMessage}>{i18n.t('LOGOUT_MSG_KEY')}</p>
        </Grid>
      ),
      footer: (
        <Grid>
          <Button
            id="logout-button"
            submitButton
            onClick={() => authenticateLogout()}
          >
            {i18n.t('FINALIZE_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  const handleOpenChangeRegion = (region: {
    name: string;
    code: string;
    url: string;
  }) => {
    modalOpen({
      title: i18n.t('CHANGE_REGION_KEY'),
      subtitle: i18n.t('CHANGE_REGION_MSG_KEY'),
      content: <FormSwitchRegion region={region} modalClose={modalClose} />,
    });
  };

  React.useEffect(() => {
    if (operator_uuid) {
      getOperatorRequest(operator_uuid);
    }
  }, [operator_uuid, getOperatorRequest]);

  const languageDictionary = (key, lang) => {
    const parseOperatorLangToI18n = {
      en: 'en-US',
      'pt-br': 'pt-BR',
      es: 'es',
    };

    const parseI18nToOperator = {
      'en-US': 'en',
      'pt-BR': 'pt-br',
      es: 'es',
    };

    return key === 'i18n'
      ? parseOperatorLangToI18n[lang]
      : parseI18nToOperator[lang];
  };

  const navLogo = '/images/SkyoneAutoskyLogo.png';

  React.useEffect(() => {
    if (operatorDetails) {
      if (operatorDetails.operator_uuid === operator_uuid) {
        changeLanguage(languageDictionary('i18n', operatorDetails?.language));
      }
    }
  }, [operatorDetails, operator_uuid]);

  const getLogoPath = () => {
    if (isClientOperator(role)) {
      return permissions?.list_environment ? '/environments' : '/clients';
    }
    if (companySelected && partnerSelected) {
      return '/dashboard/partner';
    }
    return '/all-environments';
  };

  const handleClick = () => {
    selectCompany(null);
    selectPartner(null);
    history.push('/all-environments');
  };

  const { width } = useWindowDimensions();

  return (
    <React.Fragment>
      <div className={classes.root}>
        <AppBar
          position="static"
          className={clsx(classes.userView, {
            [classes.superAdminView]: inSuperAdminView,
            [classes.adminView]: inAdminView(role, companySelected),
            [classes.operatorView]: inOperatorView(role, companySelected),
          })}
        >
          <Toolbar variant="dense" className={classes.navbar}>
            <div className={classes.group}>
              <IconButton
                id="btn-menu"
                edge="start"
                className={clsx(classes.menuButton, {
                  [classes.menuButtonSuperAdmin]: inSuperAdminView,
                  [classes.menuButtonSuperAdminMobile]:
                    inSuperAdminView && width <= 600,
                  [classes.menuButtonMobile]: width <= 600,
                })}
                onClick={toggleMenu}
              >
                <MenuIcon className={classes.menuButtonIcon} />
              </IconButton>
              <Link className={classes.logoLink} to={getLogoPath}>
                <img
                  className={clsx(classes.logo, {
                    [classes.logoMobile]: width <= 600,
                  })}
                  src={navLogo}
                  alt="Logo Autosky"
                />
              </Link>
              {role === 'superadmin' && companySelected && (
                <Button
                  id="superadmin-select"
                  onClick={handleClick}
                  size="medium"
                  className={clsx(classes.buttonSelect, {
                    [classes.buttonSelectMobile]: width <= 600,
                  })}
                  startIcon={
                    <VerifiedUserIcon className={classes.buttonIcon} />
                  }
                >
                  <Typography
                    className={clsx(classes.topBarRole, {
                      [classes.topBarRoleMobile]: width <= 600,
                    })}
                  >
                    {i18n.t('SUPERADMIN_KEY')}
                  </Typography>
                </Button>
              )}
              {inSuperAdminView && (
                <Button
                  id="superadmin-select"
                  onClick={handleClick}
                  size="medium"
                  className={clsx(classes.buttonSelect, {
                    [classes.buttonSuperAdminSelectMobile]: width <= 600,
                    [classes.buttonSuperAdminSelect]: !companySelected,
                    [classes.buttonSelectMobile]:
                      width <= 600 && companySelected,
                  })}
                  startIcon={
                    <VerifiedUserIcon className={classes.buttonIcon} />
                  }
                >
                  <Typography
                    className={clsx(classes.topBarRoleSuperAdmin, {
                      [classes.topBarRoleSuperAdminMobile]: width <= 600,
                    })}
                  >
                    {i18n.t('SUPERADMIN_KEY')}
                  </Typography>
                </Button>
              )}
              {role === 'admin' && (
                <Button
                  id="admin-select"
                  onClick={handleClick}
                  size="medium"
                  className={clsx(classes.buttonSelect, {
                    [classes.buttonAdminSelectMobile]: width <= 600,
                    [classes.buttonSelectAdmin]: !companySelected,
                    [classes.buttonSelectMobile]:
                      width <= 600 && companySelected,
                  })}
                  startIcon={
                    <VerifiedUserIcon className={classes.buttonIcon} />
                  }
                >
                  <Typography
                    className={clsx(classes.topBarRole, {
                      [classes.topBarRoleMobile]: width <= 600,
                    })}
                  >
                    {i18n.t('ADMIN_KEY')}
                  </Typography>
                </Button>
              )}
              {role === 'operator' && (
                <Button
                  id="operator-select"
                  onClick={handleClick}
                  size="medium"
                  className={clsx(classes.buttonSelect, {
                    [classes.buttonOperatorSelectMobile]:
                      width <= 600 && !companySelected,
                    [classes.buttonSelectOperator]: !companySelected,
                    [classes.buttonSelectMobile]:
                      width <= 600 && companySelected,
                  })}
                  startIcon={
                    <VerifiedUserIcon className={classes.buttonIcon} />
                  }
                >
                  <Typography
                    className={clsx(classes.topBarRole, {
                      [classes.topBarRoleMobile]: width <= 600,
                    })}
                  >
                    {i18n.t('OPERATOR_KEY')}
                  </Typography>
                </Button>
              )}
              {width > 600 && !permissions?.can_view_all_resources && (
                <>
                  <Button
                    id="select-company"
                    onClick={openSelectCompany}
                    disabled={companyList?.count === 1}
                    size="medium"
                    className={clsx(classes.buttonSelectPartner, {
                      [classes.buttonSelectSuperAdmin]: !companySelected,
                    })}
                    startIcon={
                      <ScreenShareIcon className={classes.buttonIcon} />
                    }
                    endIcon={<ExpandMoreIcon className={classes.expandIcon} />}
                  >
                    <small>{i18n.t('COMPANY_KEY')}</small>
                    {companySelected ? (
                      <Typography className={classes.topBarTextsSuperAdmin}>
                        {companySelected.name}
                      </Typography>
                    ) : (
                      <Typography className={classes.topBarTextsSuperAdmin}>
                        {i18n.t('COMPANY_KEY')}
                      </Typography>
                    )}
                  </Button>

                  <Button
                    id="select-partner"
                    onClick={() => {
                      if (!companySelected) {
                        messagesRequest({
                          type: 'info',
                          message: i18n.t('SELECT_COMPANY_KEY'),
                        });
                      } else {
                        openSelectPartner();
                      }
                    }}
                    size="medium"
                    className={clsx(classes.buttonSelectPartner, {
                      [classes.buttonSelectSuperAdmin]: !companySelected,
                    })}
                    startIcon={<LayersIcon className={classes.buttonIcon} />}
                    endIcon={<ExpandMoreIcon className={classes.expandIcon} />}
                    disabled={partnerLoading || partnerList?.count === 1}
                  >
                    <small>{i18n.t('PARTNER_KEY')}</small>
                    {partnerSelected ? (
                      <Typography className={classes.topBarTextsSuperAdmin}>
                        {partnerSelected.shortName}
                      </Typography>
                    ) : (
                      <Typography className={classes.topBarTextsSuperAdmin}>
                        {i18n.t('PARTNER_KEY')}
                      </Typography>
                    )}
                  </Button>
                </>
              )}
            </div>
            {availableRegions && (
              <Button
                id="change-region"
                className={classes.buttonRegion}
                onClick={event =>
                  openDropMenu({
                    event,
                    header: {
                      title: i18n.t('CHANGE_REGION_KEY'),
                    },
                    items: (
                      <>
                        {availableRegions.map(item => (
                          <DropMenuItem
                            key={item?.code}
                            id={`change-region-${item?.code}`}
                            className={classes.menuItem}
                            onClick={() => handleOpenChangeRegion(item)}
                            disabled={item?.code === currentRegion}
                          >
                            {item?.name}
                          </DropMenuItem>
                        ))}
                      </>
                    ),
                  })
                }
              >
                <PublicIcon fontSize="small" />{' '}
                {
                  availableRegions.find(item => item?.code === currentRegion)
                    ?.abbreviation
                }
              </Button>
            )}
            <Grid item className={classes.profileSelector}>
              <IconButton
                className={classes.profileButton}
                id="btn-profile-options"
                onClick={event =>
                  openDropMenu({
                    event,
                    items: (
                      <>
                        {width <= 600 && !permissions?.can_view_all_resources && (
                          <>
                            <DropMenuItem
                              id="btn-profile"
                              className={classes.menuItem}
                              onClick={() => {
                                openSelectCompany();
                                closeDropMenu();
                              }}
                            >
                              <Grid item>
                                {companySelected ? (
                                  <>
                                    <Typography className={classes.smallText}>
                                      {i18n.t('COMPANY_KEY')}
                                    </Typography>
                                    <Typography
                                      className={clsx(classes.menuSelectText, {
                                        [classes.menuSelectTextSuperAdminView]: inSuperAdminView,
                                        [classes.menuSelectTextAdminView]: inAdminView(
                                          role,
                                          companySelected
                                        ),
                                        [classes.menuSelectTextOperatorView]:
                                          role === 'operator' &&
                                          !companySelected,
                                      })}
                                    >
                                      {companySelected.shortName}
                                    </Typography>
                                  </>
                                ) : (
                                  <Typography
                                    className={clsx(classes.menuSelectText, {
                                      [classes.menuSelectTextSuperAdminView]: inSuperAdminView,
                                      [classes.menuSelectTextAdminView]: inAdminView(
                                        role,
                                        companySelected
                                      ),
                                      [classes.menuSelectTextOperatorView]: inOperatorView(
                                        role,
                                        companySelected
                                      ),
                                    })}
                                  >
                                    {i18n.t('COMPANY_KEY')}
                                  </Typography>
                                )}
                              </Grid>
                              <ScreenShareIcon
                                className={clsx(classes.menuSelectIcon, {
                                  [classes.menuSelectIconSuperAdminView]: inSuperAdminView,
                                  [classes.menuSelectIconAdminView]: inAdminView(
                                    role,
                                    companySelected
                                  ),
                                  [classes.menuSelectIconOperatorView]: inOperatorView(
                                    role,
                                    companySelected
                                  ),
                                })}
                              />
                            </DropMenuItem>
                            <Divider />
                            <DropMenuItem
                              id="btn-profile"
                              className={classes.menuItem}
                              onClick={openSelectPartner}
                            >
                              <Grid item>
                                {partnerSelected ? (
                                  <>
                                    <Typography className={classes.smallText}>
                                      {i18n.t('PARTNER_KEY')}
                                    </Typography>
                                    <Typography
                                      className={clsx(classes.menuSelectText, {
                                        [classes.menuSelectTextSuperAdminView]: inSuperAdminView,
                                        [classes.menuSelectTextAdminView]: inAdminView(
                                          role,
                                          companySelected
                                        ),
                                        [classes.menuSelectTextOperatorView]:
                                          role === 'operator' &&
                                          !companySelected,
                                      })}
                                    >
                                      {partnerSelected.shortName}
                                    </Typography>
                                  </>
                                ) : (
                                  <Typography
                                    className={clsx(classes.menuSelectText, {
                                      [classes.menuSelectTextSuperAdminView]: inSuperAdminView,
                                      [classes.menuSelectTextAdminView]: inAdminView(
                                        role,
                                        companySelected
                                      ),
                                      [classes.menuSelectTextOperatorView]: inOperatorView(
                                        role,
                                        companySelected
                                      ),
                                    })}
                                  >
                                    {i18n.t('PARTNER_KEY')}
                                  </Typography>
                                )}
                              </Grid>
                              <LayersIcon
                                className={clsx(classes.menuSelectIcon, {
                                  [classes.menuSelectIconSuperAdminView]: inSuperAdminView,
                                  [classes.menuSelectIconAdminView]: inAdminView(
                                    role,
                                    companySelected
                                  ),
                                  [classes.menuSelectIconOperatorView]: inOperatorView(
                                    role,
                                    companySelected
                                  ),
                                })}
                              />
                            </DropMenuItem>
                            <Divider />
                          </>
                        )}
                        <Permission value="list_self_operator_details">
                          <DropMenuItem
                            id="btn-profile"
                            className={classes.menuItem}
                            onClick={() => {
                              history.push(
                                `/operators/${operator_uuid}/edit`,
                                'dashboard'
                              );
                              closeDropMenu();
                            }}
                          >
                            {i18n.t('PROFILE_KEY')}
                            <PhotoIcon />
                          </DropMenuItem>
                          <Divider />
                        </Permission>
                        <a
                          href={tutorial[i18n.language.split('-')[0]]}
                          target="_blank"
                          rel="noopener noreferrer" //NOSONAR ignoring sonar for this line to open in same tab
                          className={classes.linksExternal}
                        >
                          <DropMenuItem
                            id="btn-tutorial"
                            className={classes.menuItem}
                          >
                            {i18n.t('TUTORIAL_KEY')}
                            <HelpCenterIcon />
                          </DropMenuItem>
                        </a>
                        <Divider />
                        <DropMenuItem
                          id="btn-logout"
                          className={classes.menuItem}
                          onClick={handleConfirmLogout}
                        >
                          {i18n.t('GO_OUT_KEY')}
                          <LogoutIcon />
                        </DropMenuItem>
                      </>
                    ),
                  })
                }
              >
                <Avatar
                  variant="rounded"
                  className={clsx(classes.avatar, {
                    [classes.avatarSuperAdmin]: inSuperAdminView,
                    [classes.avatarAdmin]: inAdminView(role, companySelected),
                    [classes.avatarOperator]: inOperatorView(
                      role,
                      companySelected
                    ),
                  })}
                />
                {width > 600 && (
                  <Typography className={classes.profileNameSuperAdmin}>
                    {operator_first_name} {operator_last_name}
                  </Typography>
                )}

                <Grid container item xs={1}>
                  <ArrowDropDownIcon
                    className={clsx(classes.dropDownIcon, {
                      [classes.dropDownIconSuperAdmin]: inSuperAdminView,
                    })}
                  />
                </Grid>
              </IconButton>
              <ChangeLanguage insideTemplate />
            </Grid>
          </Toolbar>
        </AppBar>
      </div>

      <DropMenu
        anchorEl={anchorEl}
        onClose={closeDropMenu}
        header={dropHeader}
        footer={dropFooter}
        items={dropItems}
      />
      <DialogAlert alignActionButtons="alignActionButtons" {...alert} />
    </React.Fragment>
  );
};

const mapStateToProps = ({
  authenticate: { partnerSelected, companySelected, data },
  operators: { operatorDetails },
  companies: { companyList },
  partners: { partnerList, isLoading },
}: ApplicationState) => ({
  operator_uuid: data?.operator_uuid!,
  availableRegions: data?.available_regions!,
  currentRegion: data?.logged_region!,
  operatorDetails,
  companyList,
  companySelected,
  partnerSelected,
  partnerList,
  partnerLoading: isLoading,
  permissions: data?.permissions,
  role: data?.role,
  operator_first_name: data?.operator_first_name,
  operator_last_name: data?.operator_last_name,
});

export default connect(mapStateToProps, {
  selectCompany,
  selectPartner,
  modalOpen,
  modalClose,
  getOperatorRequest,
  messagesRequest,
  authenticateLogout,
})(TopNavBar);
